import React from 'react'
import { sectionForDisplayMode } from './SectionTypes'



const Section = ({ section }) => {

  const SpecificSection = sectionForDisplayMode(section.display_mode)
  return (
    <SpecificSection section={section} />
  )
}

export default Section
